export enum HOME_LOGS_HEADERS {
  UID = 'uid',
  PROCESS_NAME = 'processName',
  SOFTWARE_VERSION = 'softwareVersion',
  UPLOAD_TIME = 'uploadTime',
  URL_INFO = 'urlInfo',
}
